import { Component } from "@/decorators";
import ProdutoDcbModel from "@/models/produto/produtoDcbModel";
import produtoDcbService from "@/services/produto/produtoDcbService";

import EditComponentBase from "../editComponentBase";

@Component
export default class ProdutoDcbEditComponent extends EditComponentBase<ProdutoDcbModel> {
    private async beforeMount() {
        await this.setPropsCached(produtoDcbService, "dcbs", new ProdutoDcbModel());
    }
}
